import { useEffect } from 'react';
import { Modal, Form, Input, InputNumber, Checkbox, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { REGIONAL_QUANTITY_OPTIONS } from '../../lottery/core/const';

const ModalPrize = ({ visible, onCancel, onSubmit, initialValues }) => {
    const [form] = Form.useForm();
    const { t } = useTranslation();

    // Watch onlyMarker field value
    const isOnlyMarker = Form.useWatch('onlyMarker', form);

    useEffect(() => {
        if (visible) {
            if (initialValues) {
                form.setFieldsValue({
                    ...initialValues,
                    onlyMarker: initialValues.onlyMarker || false,
                });
            } else {
                form.resetFields();
            }
        }
    }, [visible, initialValues, form]);

    // Reset quantity to 8 when onlyMarker is unchecked
    useEffect(() => {
        if (isOnlyMarker === false) {
            form.setFieldValue('quantity', 8);
        }
    }, [isOnlyMarker, form]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            onSubmit(values);
        } catch (error) {
            console.error('Validation failed:', error);
        }
    };

    return (
        <Modal
            title={initialValues ? t('editPrize') : t('newPrize')}
            open={visible}
            onOk={handleOk}
            onCancel={onCancel}
            okText={t('confirm')}
            cancelText={t('cancel')}
            width={600}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{
                    quantity: 8,
                    onlyMarker: false,
                    spinCount: 1,
                }}
            >
                <Form.Item
                    name="title"
                    label={t('prizeName')}
                    rules={[
                        { required: true }
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="onlyMarker"
                    valuePropName="checked"
                >
                    <Checkbox>{t('onlyMarker')}</Checkbox>
                </Form.Item>

                <Form.Item
                    name="quantity"
                    label={t('quantity')}
                    rules={[
                        { required: true },
                        {
                            type: 'number',
                            min: 1,
                            message: t('quantityMinOne') || 'Quantity must be at least 1'
                        }
                    ]}
                >
                    {isOnlyMarker ? (
                        <InputNumber
                            style={{ width: '100%' }}
                            min={1}
                            placeholder={t('enterQuantity') || 'Enter quantity'}
                        />
                    ) : (
                        <Select
                            style={{ width: '100%' }}
                            options={REGIONAL_QUANTITY_OPTIONS.map(value => ({
                                value,
                                label: String(value)
                            }))}
                        />
                    )}
                </Form.Item>

                <Form.Item
                    name="spinCount"
                    label={t('spinCount')}
                    rules={[{
                        required: true,
                    },
                    {
                        type: 'number',
                        min: 1,
                    }]}
                >
                    <InputNumber
                        style={{ width: '100%' }}
                        min={1}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ModalPrize;
